import {JsonConvert, JsonConverter, JsonCustomConvert} from 'json2typescript';
import {TSMap} from 'typescript-map';
import {EmailBanner} from '../model/email/emailBanner';

@JsonConverter
export class TSStringToStringMapConverter implements JsonCustomConvert<TSMap<string,string>> {

    deserialize(json: any): TSMap<string, string> {

        const temp:TSMap<string,string> = new TSMap();

        /*for (const text of json) {
            temp.set(text[0], text[1]);
        }*/
        for (const key of Object.keys(json)) {
            temp.set(key, json[key]);
        }

        return temp;
    }

    serialize(data: TSMap<string, string>): any {
        console.log(JSON.stringify(data));
        return JSON.stringify(data);
    }
}
